import { ISensorInterface } from './ISensorInterface';
import { TranslationService } from '../services/translation.service';
export class BaseSensor implements ISensorInterface{
	name:string;
	unit:string;

	maxValue:number;
	minValue:number;
	currentValue:number;
	granularity:number;
	specialValues:Map<number,string>;
	hooks:Map<string,CallableFunction>;
	setName(_name: string){
		this.name = _name;
	}
	getName():string{
		return this.name;
	}
	registerHook(name:string,fn:CallableFunction){
		this.hooks.set(name,fn);
	}

	public getUnit(value?:number):string{
		let v = value;
		if(v === undefined){
			v = this.currentValue;
		}
		if(this.specialValues.has(v)){
			return '';
		}
		return TranslationService.getInstance().tr(this.unit);
	}

	setUnit(_unit: string):void{
		this.unit = _unit;
	}
	getMinValue():number{

		return this.minValue;
	}
	setMinValue(val: number):void{
		if(!this.maxValue || val < this.maxValue){
			this.minValue = val;
		}else{
			console.log("error setting min-value on sensor "+this.name+ ": max-value is set and smaller");
		}
	}

	getMaxValue():number{
		return this.maxValue;
	}
	setMaxValue(val: number):void{
		if(!this.minValue || val > this.minValue){
			this.maxValue = val;
		}else{
			console.log("error setting max-value on sensor "+this.name+ ": min-value is set and smaller");
		}
	}

	public setCurrentValue(val: number, ignoreHook?:boolean):void{
		this.currentValue = val;
		if(this.currentValue > this.maxValue){
			this.currentValue = this.maxValue;
		}
		if(this.currentValue < this.minValue){
			this.currentValue = this.minValue;
		}
		if(!ignoreHook){
			if(this.hooks.has('valueChanged')){
				this.hooks.get('valueChanged')(this.currentValue);
			}
		}
	}
	
	public getCurrentValue():number{
		return this.currentValue;
	}
	
	getGranularity():number{
		return this.granularity;
	}
	
	setGranularity(gran: number){
		this.granularity = gran;
	}

	toString(){
		if(this.specialValues.has(this.currentValue)){
			return TranslationService.getInstance().tr(this.specialValues.get(this.currentValue));
		}
		switch(this.granularity){
			case 0.5:{
				return this.currentValue.toFixed(1)+ " "+this.getUnit();
			}
			case 0.05:{
				return this.currentValue.toFixed(2)+ " "+this.getUnit();	
			}
			default:{
				return this.currentValue + " "+this.getUnit();
			}
		
		}
	}
	static fromArgs(name:string, currentValue: number, min:number,max: number, granularity:number, unit:string):BaseSensor{
		let s = new BaseSensor();
		s.setName(name);
		s.setMinValue(min);
		s.setMaxValue(max);
		s.setCurrentValue(currentValue);
		s.setGranularity(granularity);
		s.setUnit(unit);
		return s;
	}


	public setSpecialValue(value:number,valueReplacement:string){
		this.specialValues.set(value,valueReplacement);
	}
	public hasSpecialValue(key:number):boolean {
		return this.specialValues.has(key);
	}
	public getSpecialValue(key:number){
		return this.specialValues.get(key);
	}



	constructor(sensor?: BaseSensor){
		this.hooks = new Map<string,CallableFunction>();
		this.specialValues = new Map<number,string>();
		if(sensor){
			this.setName(sensor.getName());
			this.setMinValue(sensor.getMinValue());
			this.setMaxValue(sensor.getMaxValue());
			this.setCurrentValue(sensor.getCurrentValue());
			this.setUnit(sensor.getUnit());
			this.setGranularity(sensor.getGranularity());
			this.specialValues=new Map<number,string>(sensor.specialValues);
		}else{
			this.minValue = -999999999;
			this.currentValue = 0;
			this.maxValue =  999999999;
			this.name = 'unknown';
			this.granularity = 0.1;
			this.unit = 'N/A';
		}
	}


}